import * as React from 'react';

export interface IconProps extends React.ComponentProps<'svg'> {
  className?: string;
  height?: string;
  width?: string;
  viewBox?: string;
}

/**
 * A wrapper for SVG icons. Expects an svg `path` element (or elements) to be passed as `children`.
 * The svg path should conform to a viewbox of 24×24px
 *
 * @param props
 */
export const IconWrapper: React.FC<IconProps> = ({
  className = '',
  width = '24',
  height = width || '24',
  viewBox = `0 0 ${width} ${height}`,
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} fill-current`}
      {...rest}
    />
  );
};
